export default __webpack_public_path__ + "2cac4cd59c00985ccc795459c97283bc.jpg";